export default __webpack_public_path__ + "static/google_Desktop10-30a12be50e7f2dca691da92c32840e32.svg";